export enum OpportunityContractDocumentStatusOption {
  WAITING = '394e8ecd-f278-4561-bb0e-7beb0b9d72f3',
  APPROVED = '711d904c-fda6-422f-b2e4-819adb503a34',
  DENIED = 'daca97cf-812d-46c0-baa3-905c6e9c2867'
}
